import Axios from 'axios';
import Promise from 'bluebird';

Promise.config({
    warnings: false,
    longStackTraces: false,
    cancellation: true,
});

const getClient = () => {

    const options = {
        baseURL: process.env.VUE_APP_BACKEND_URL,
        withCredentials: true
    };

    const client = Axios.create(options);

    /*
     // Add a request interceptor
     client.interceptors.request.use(
     requestConfig => requestConfig,
     (requestError) => {
     return Promise.reject(requestError);
     },
     );

     // Add a response interceptor
     client.interceptors.response.use(
     response => response,
     (error) => {
     return Promise.reject(error);
     },
     );
     */

    return client;
};

let client = getClient();

class Api {

    constructor() {
    }

    newClient() {
        this.client = getClient();
        return this;
    }

    getClient() {
        this.client = this.client || client;
        return this.client;
    }

    get(url, params = {}) {

        let filteredParams = {};

        for (let key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key) && !['', false].includes(params[key])) {
                filteredParams[key] = params[key];
            }
        }

        return this.request({
            url: url,
            method: 'get',
            params: filteredParams,
        })
    }

    post(url, params = {}) {

        let filteredParams = {};

        for (let key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key) && !['', false].includes(params[key])) {
                filteredParams[key] = params[key];
            }
        }

        return this.request({
            url: url,
            method: 'post',
            data: filteredParams,
        })
    }

    request(configRequest) {
        return new Promise((resolve, reject, onCancel) => {
            const cancelSource = Axios.CancelToken.source();
            const cancelToken = Object.prototype.hasOwnProperty.call(configRequest, 'cancelToken') ? configRequest.cancelToken : cancelSource.token;
            const requestConfig = {...configRequest, ...{cancelToken}};

            onCancel(() => {
                cancelSource.cancel()
            });

            return this.getClient().request(requestConfig)
                .then(resolve)
                .catch(reject)
        });
    }

}

export default new Api()
